module.exports = __webpack_public_path__ + "img/rank3.5ef23015.png";